if (!customElements.get('featured-collection-countdown')) {
  class FeaturedCollectionCountdown extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);

      this.endDate = this.parseDate(this.getAttribute('end-date'));
      this.hideOnExpire = this.getAttribute('hide-on-expire') === 'true';
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.timerEl = this.querySelector('.countdown-timer__timer');
      this.expiredEl = this.querySelector('.countdown-timer__expired');

      if (!this.endDate) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    parseDate(value) {
      if (!value) return null;

      const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
      if (!match) return null;

      const date = new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        Number(match[4] || 0),
        Number(match[5] || 0)
      );

      return Number.isNaN(date.getTime()) ? null : date;
    }

    tick() {
      const distance = this.endDate.getTime() - Date.now();

      if (distance <= 0) {
        clearInterval(this.interval);

        if (this.hideOnExpire) {
          this.hidden = true;
        } else {
          if (this.timerEl) this.timerEl.hidden = true;
          if (this.expiredEl) this.expiredEl.hidden = false;
        }

        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('featured-collection-countdown', FeaturedCollectionCountdown);
}
